/**
 * Card gallery main-image navigation (prev/next arrows + hover second image).
 * Used when thumbnail navigation is enabled on product cards.
 */

/** @param {Element} gallery */
function bindMainImageNav(gallery) {
  if (gallery.getAttribute('data-main-nav-bound') === 'true') return;
  gallery.setAttribute('data-main-nav-bound', 'true');

  const slideshow = gallery.querySelector('slideshow-component');
  const track = slideshow?.querySelector('slideshow-slides');
  if (!track) return;

  const slideEls = gallery.querySelectorAll('slideshow-slide');
  const n = slideEls.length;
  if (n < 2) return;

  const prev = gallery.querySelector('.card-gallery__image-nav--prev');
  const next = gallery.querySelector('.card-gallery__image-nav--next');
  let i = 0;

  slideEls.forEach((slide) => {
    slide.style.flexShrink = '0';
    slide.style.width = '100%';
  });

  /** @param {number} idx */
  function go(idx) {
    i = Math.max(0, Math.min(n - 1, idx));
    slideEls.forEach((slide, slideIdx) => {
      slide.setAttribute('aria-hidden', slideIdx === i ? 'false' : 'true');
    });
    track.style.transition = 'transform 0.3s ease';
    track.style.transform = `translateX(-${i * 100}%)`;
    track.style.display = 'flex';
    if (prev instanceof HTMLButtonElement) prev.disabled = i <= 0;
    if (next instanceof HTMLButtonElement) next.disabled = i >= n - 1;
  }

  go(0);

  prev?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    go(i - 1);
  });

  next?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    go(i + 1);
  });

  if (gallery.hasAttribute('data-card-gallery-hover-second')) {
    gallery.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      go(i + 1);
    });
    gallery.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      go(i - 1);
    });
  }
}

/**
 * @param {ParentNode} [root]
 */
export function scanCardGalleryMainNav(root = document) {
  if (!root?.querySelectorAll) return;
  root.querySelectorAll('[data-card-gallery-main-nav]').forEach((gallery) => {
    if (gallery instanceof Element) bindMainImageNav(gallery);
  });
}

function init() {
  scanCardGalleryMainNav(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

setTimeout(init, 400);

document.addEventListener('shopify:section:load', () => {
  setTimeout(init, 100);
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('[data-card-gallery-main-nav]')) bindMainImageNav(node);
      node.querySelectorAll('[data-card-gallery-main-nav]').forEach((gallery) => {
        if (gallery instanceof Element) bindMainImageNav(gallery);
      });
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
